// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"807":"0b5cb9a9","2589":"d6fdf0fb","8234":"7a17ac13","9103":"b9ea4917","9603":"74fab3b8"}[chunkId] + ".css";
};